import React from 'react';

export const BedroomsIcon = props => (
  <svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#545D69" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5.688 1l4.675 3.325h9.004V20H1.123V4.333h3.022M1.106 9.472h7.463M19.284 11.739h-5.125M14.242 9.261v4.956" />
      <path d="M10.948 15.185H8.61v4.81" />
    </g>
  </svg>
);
